import React, { useState, Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted';
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import Collapsible from 'react-collapsible';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import DocumentacionFC_30Component from './DocumentacionFC_30Component';
import {
    ObtenerClientePorLogin30,
    obtenerContadorDeFechaFolio,
    agregarFC_30Accion,
    ObtenerInstalacionesCliente,
    resetDataFC_30,
    agregarFC_30SolicitudBorrador,
    actualizarFC_30SolicitudBorrador,
    enviarBorradorFC_30,
    actualizarFC_30Solicitud,

    actualizarFC_30Estatus,
    actualizarModoBorradorFC_30,
    actualizarModoCorrecionFC_30,
    actualizarFC_30PaginaActiva
} from '../../../redux/DucksBeneficiario/FC_30Ducks';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC30BeneficiarioComponent.module.css'
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
const { useEffect, useRef } = React;
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TablaProducto from './TablaProducto';
import InfoBar from '../../App/InfoBar'
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { Formik } from 'formik'
function FormularioFC30BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const currentUser = useSelector(store => store.Usuario.data)
    const idUsuario = usuario.data.user[0].id
    var fechaHoy = moment().format('YYYY-MM-DD');

    let fc_30 = useSelector(store => store.FC_30Solicitud.fc_30)
    let fc_30Productos = useSelector(store => store.FC_30Solicitud.productos)
    let fc_30Map = useSelector(store => store.FC_30Solicitud.fc_30Map)
    let fc_30ProductosMap = useSelector(store => store.FC_30Solicitud.productosMap)
    const modoEdicionBorrador = useSelector(store => store.FC_30Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_30Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_30Solicitud.data)

    let dataCliente = useSelector(store => store.FC_30Solicitud.cliente)
    let instalacionesCliente = useSelector(store => store.FC_30Solicitud.instalacionesCliente)
    let dataLogin = useSelector(store => store.FC_30Solicitud.dataLogin)


    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [idfc30_notificaciontrasladodepr, setidfc30_notificaciontrasladodepr] = useStateIfMounted(0)
    const idfc30_notificaciontrasladodeprRef = useRef(idfc30_notificaciontrasladodepr)

    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin30({ idlogin: usuario.data.user[0].id }))
    }, [])

    const idestatusdesolicitudes = 2
    const idlogin = idUsuario

    /*Controlar el modo borrador del formulario*/
    const store = useSelector(store => store)
    const noActualizarBorrador = useRef(true)
    /*Cargar informcion del fc_30 si hay guardada*/
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_30 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_30))) {

            if (fc_30Productos.data) {
                if (fc_30Productos.data.data) {
                    setProductos(fc_30Productos.data.data)
                } else {
                    setProductos(fc_30Productos.data)
                }
            }
            let fechasolicitud = moment(fc_30.fechasolicitud).format('YYYY-MM-DD')
            let fechapropuestaactividad = moment(data.fechapropuestaactividad).format('YYYY-MM-DD')
        }
    }, [fc_30, data])

    React.useEffect(() => {
        if (!(JSON.stringify([]) === JSON.stringify(instalacionesCliente))) {
            if (data.propiasalida) {
                for (let dato in instalacionesCliente) {
                    if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.alias === data.tipoinstalacionsalida) {
                        setResposableRelacionados(instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                    }
                }
            }
            if (data.propiarecepcion) {
                for (let dato in instalacionesCliente) {
                    if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.alias === data.tipoinstalacionrecepcion) {
                        setResposableRecepcion(instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                    }
                }
            }
        }
        if (!(JSON.stringify([]) === JSON.stringify(instalacionesBusquedaCliente))) {
            if (data.otroclienterecepcion) {
                for (let dato in instalacionesBusquedaCliente) {
                    if (instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.alias === data.tipoinstalacionrecepcion) {
                        setResposableRecepcionOtro(instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                    }
                }
            }
        }
    }), []

    React.useEffect(() => {
        if (fc_30Productos.data) {
            if (fc_30Productos.data.data) {
                setProductos(fc_30Productos.data.data)
            } else {
                setProductos(fc_30Productos.data)
            }
        }

    }, [fc_30Productos])


    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_30':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarSolicitudBorradorFC_30':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const botonEnviarSolicitudFC_30 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_30'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores
                Los archivos de la seccion final no se guardarán puesto que es un borrador del formulario`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudBorradorFC_30 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_30'
        })
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_30 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    /*Controlar las el formulario con las paginas*/
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const paginaActiva = useSelector(store => store.FC_30Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Productos', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        if (productos.length === 0 && nombresParaPaginas[paginaActiva - 1] === 'Productos') {
            settexto('o por lo menos un producto')
            setvalidacion(true)
        } else {
            const result = await validation(valores)
            if (JSON.stringify(result) !== '{}') {
                settexto('')
                setvalidacion(true)
            } else {
                dispatch(actualizarFC_30PaginaActiva(paginaActiva + 1))
            }
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_30PaginaActiva(paginaActiva - 1))
    }
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])
    const [productos, setProductos] = React.useState([])
    const handdleProducto = (objectProducto) => {
        setProductos(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrev = async (objectProducto) => {
        if (objectProducto.data.idfc30_anexoproducto) {
            await dispatch(eliminarFC_30AnexoProductoBD(objectProducto.data.idfc30_anexoproducto))
        }
        const filtro = productos.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductos(filtro)

    }
    const handdleEditProductosPrev = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_30ProductosMap.length > 0) {
            const filtro = productos.findIndex(anexo => anexo.idfc30_anexoproducto === objectProducto.id)
            let editar = { ...productos[Number(filtro)] }
            const filtroEliminar = productos.filter(anexo => anexo.idfc30_anexoproducto !== objectProducto.id)

            editar.numerocertificado = objectProducto.numerocertificado
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.volumen = objectProducto.volumen
            editar.numeroanalisislaboratorio = objectProducto.numeroanalisislaboratorio
            editar.numerolote = objectProducto.numerolote
            filtroEliminar.push(editar)
            setProductos(filtroEliminar)
        } else {
            const filtro = productos.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productos
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].volumen = objectProducto.volumen
            newProductos[Number(filtro)].numeroanalisislaboratorio = objectProducto.numeroanalisislaboratorio
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            setProductos(newProductos)
        }
    }

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const validation = values => {
        let errores = {};
        const textoError = 'Campo obligratorio'
        const textoCheck = 'Debe de seleccionar al menos una opción'
        if (paginaActiva === 1) {
            if (!values.fechapropuestaactividad) { errores.fechapropuestaactividad = textoError }
            if (!values.responsabletraslado) { errores.responsabletraslado = textoError }
            if (!values.otrainstalacion && !values.paracomprayventa) { errores.otrainstalacion = textoCheck }
            if (!values.superviciondocumental && !values.supervicionsitio) { errores.superviciondocumental = textoCheck }
            if (!values.propiasalida && !values.noregistradasalida) { errores.propiasalida = textoCheck }
            if (values.propiasalida === true) {
                if (!values.responsableinstalacionessolicit) { errores.responsableinstalacionessolicit = textoError }
                if (!values.correoelectronicosolicitante) { errores.correoelectronicosolicitante = textoError }
                if (!values.telefonosolicitante) { errores.telefonosolicitante = textoError }
                if (!values.domiciliosolicitante) { errores.domiciliosolicitante = textoError }
            }
            if (values.superviciondocumental && values.propiasalida && values.noregistradarecepcion) { errores.superviciondocumental = 'Únicamente podrá seleccionar supervisión en sitio' }
            if (values.noregistradasalida === true) {
                if (!values.razonsocialsolicitante) { errores.razonsocialsolicitante = textoError }
                if (!values.responsableinstalacionessolicit) { errores.responsableinstalacionessolicit = textoError }
                if (!values.correoelectronicosolicitante) { errores.correoelectronicosolicitante = textoError }
                let tel = values.telefonosolicitante
                if (!tel) {
                    errores.telefonosolicitante = textoError
                } else {
                    if (tel.toString().length !== 10) {
                        errores.telefonosolicitante = 'Debe contener 10 digitos'
                    }
                }
                if (!values.domiciliosolicitante) { errores.domiciliosolicitante = textoError }
                else {
                    //let longitudDomicilio = values.domiciliosolicitante.split(',')
                    if (values.domiciliosolicitante.length < 15) { errores.domiciliosolicitante = "Ingresar el domicilio completo (Calle, Número, Colonia, Municipio, Estado, Código postal)" }
                }
            }
            if (values.noregistradasalida && values.superviciondocumental) { errores.trasladosalida = 'Cuando la empresa no se encuentre registrada ante el COMERCAM únicamente podrá seleccionar supervisión en sitio' }
        }
        if (paginaActiva === 2) {
            if (!values.propiarecepcion && !values.otroclienterecepcion && !values.noregistradarecepcion) { errores.propiarecepcion = textoCheck }

            if (values.propiarecepcion === true) {
                if (!values.tipoinstalacionrecepcion) { errores.tipoinstalacionrecepcion = textoError }
                if (!values.responsableinstalacionesrecepci) { errores.responsableinstalacionesrecepci = textoError }
                if (!values.correoelectronicorecepcion) { errores.correoelectronicorecepcion = textoError }
                if (!values.telefonorecepcion) { errores.telefonorecepcion = textoError }
                if (!values.domiciliorecepcion) { errores.domiciliorecepcion = textoError }
            }
            if (values.otroclienterecepcion === true) {
                if (!values.numeroclienterecepcion) { errores.numeroclienterecepcion = textoError }
                if (!values.tipoinstalacionrecepcion) { errores.tipoinstalacionrecepcion = textoError }
                if (!values.responsableinstalacionesrecepci) { errores.responsableinstalacionesrecepci = textoError }
                if (!values.correoelectronicorecepcion) { errores.correoelectronicorecepcion = textoError }
                if (!values.telefonorecepcion) { errores.telefonorecepcion = textoError }
                if (!values.domiciliorecepcion) { errores.domiciliorecepcion = textoError }
            }
            if (values.noregistradarecepcion === true) {
                if (!values.razonsocialrecepcion) { errores.razonsocialrecepcion = textoError }
                if (!values.responsableinstalacionesrecepci) { errores.responsableinstalacionesrecepci = textoError }
                if (!values.correoelectronicorecepcion) { errores.correoelectronicorecepcion = textoError }

                let tel = values.telefonorecepcion
                if (!tel) {
                    errores.telefonorecepcion = textoError
                } else {
                    if (tel.toString().length !== 10) {
                        errores.telefonorecepcion = 'Debe contener 10 digitos'
                    }
                }
                if (!values.domiciliorecepcion) { errores.domiciliorecepcion = textoError }
                else {
                    //let longitudDomicilio = values.domiciliorecepcion.split(',')
                    if (values.domiciliosolicitante.length < 15) { errores.domiciliorecepcion = "Ingresar el domicilio completo (Calle, Número, Colonia, Municipio, Estado, Código postal)" }
                }
            }
            if (!values.observaciones) { errores.observaciones = textoError }
        }


        return errores;
    }

    const handleResetAllPropertys = () => {
        setProductos([])
        handleCloseModal()
        dispatch(resetDataFC_30())
    }
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()
    const botonRegistrarFC_30 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaVisita = new Date(valores.fechapropuestaactividad).toISOString()

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrecliente: dataCliente.nombrerazonsocial,
            fechapropuestaactividad: fechaVisita, responsabletraslado: valores.responsabletraslado,
            otrainstalacion: valores.otrainstalacion, paracomprayventa: valores.paracomprayventa,
            superviciondocumental: valores.superviciondocumental, supervicionsitio: valores.supervicionsitio,
            propiasalida: valores.propiasalida, noregistradasalida: valores.noregistradasalida,
            tipoinstalacionsalida: valores.tipoinstalacionsalida,
            razonsocialsolicitante: valores.razonsocialsolicitante, responsableinstalacionessolicit: valores.responsableinstalacionessolicit,
            correoelectronicosolicitante: valores.correoelectronicosolicitante, telefonosolicitante: valores.telefonosolicitante + '',
            domiciliosolicitante: valores.domiciliosolicitante, propiarecepcion: valores.propiarecepcion,
            otroclienterecepcion: valores.otroclienterecepcion, tipoinstalacionrecepcion: valores.tipoinstalacionrecepcion,
            noregistradarecepcion: valores.noregistradarecepcion, razonsocialrecepcion: valores.razonsocialrecepcion,
            numeroclienterecepcion: valores.numeroclienterecepcion, responsableinstalacionesrecepci: valores.responsableinstalacionesrecepci,
            correoelectronicorecepcion: valores.correoelectronicorecepcion, telefonorecepcion: valores.telefonorecepcion + '',
            domiciliorecepcion: valores.domiciliorecepcion, observaciones: valores.observaciones,
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const objetoCompletoFC_30 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(agregarFC_30Accion(objetoCompletoFC_30))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_30())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio


        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores.fechapropuestaactividad).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrecliente: dataCliente.nombrerazonsocial,
            fechapropuestaactividad: fechaVisita, responsabletraslado: valores.responsabletraslado,
            otrainstalacion: valores.otrainstalacion, paracomprayventa: valores.paracomprayventa,
            superviciondocumental: valores.superviciondocumental, supervicionsitio: valores.supervicionsitio,
            propiasalida: valores.propiasalida, noregistradasalida: valores.noregistradasalida,
            tipoinstalacionsalida: valores.tipoinstalacionsalida,
            razonsocialsolicitante: valores.razonsocialsolicitante, responsableinstalacionessolicit: valores.responsableinstalacionessolicit,
            correoelectronicosolicitante: valores.correoelectronicosolicitante, telefonosolicitante: valores.telefonosolicitante + '',
            domiciliosolicitante: valores.domiciliosolicitante, propiarecepcion: valores.propiarecepcion,
            otroclienterecepcion: valores.otroclienterecepcion, tipoinstalacionrecepcion: valores.tipoinstalacionrecepcion,
            noregistradarecepcion: valores.noregistradarecepcion, razonsocialrecepcion: valores.razonsocialrecepcion,
            numeroclienterecepcion: valores.numeroclienterecepcion, responsableinstalacionesrecepci: valores.responsableinstalacionesrecepci,
            correoelectronicorecepcion: valores.correoelectronicorecepcion, telefonorecepcion: valores.telefonorecepcion + '',
            domiciliorecepcion: valores.domiciliorecepcion, observaciones: valores.observaciones,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const objetoCompletoFC_30 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(agregarFC_30SolicitudBorrador(objetoCompletoFC_30))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_30())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores?.fechapropuestaactividad).toISOString()

        const solicitud = {
            idfc30_notificaciontrasladodepr: data.idfc30_notificaciontrasladodepr,
            fechasolicitud: fechaSolicitud,
            fechapropuestaactividad: fechaVisita, responsabletraslado: valores.responsabletraslado,
            otrainstalacion: valores.otrainstalacion, paracomprayventa: valores.paracomprayventa,
            superviciondocumental: valores.superviciondocumental, supervicionsitio: valores.supervicionsitio,
            propiasalida: valores.propiasalida, noregistradasalida: valores.noregistradasalida,
            tipoinstalacionsalida: valores.tipoinstalacionsalida,
            razonsocialsolicitante: valores.razonsocialsolicitante, responsableinstalacionessolicit: valores.responsableinstalacionessolicit,
            correoelectronicosolicitante: valores.correoelectronicosolicitante, telefonosolicitante: valores.telefonosolicitante + '',
            domiciliosolicitante: valores.domiciliosolicitante, propiarecepcion: valores.propiarecepcion,
            otroclienterecepcion: valores.otroclienterecepcion, tipoinstalacionrecepcion: valores.tipoinstalacionrecepcion,
            noregistradarecepcion: valores.noregistradarecepcion, razonsocialrecepcion: valores.razonsocialrecepcion,
            numeroclienterecepcion: valores.numeroclienterecepcion, responsableinstalacionesrecepci: valores.responsableinstalacionesrecepci,
            correoelectronicorecepcion: valores.correoelectronicorecepcion, telefonorecepcion: valores.telefonorecepcion + '',
            domiciliorecepcion: valores.domiciliorecepcion, observaciones: valores.observaciones,
            idestatusdesolicitudes: 1, idlogin: idlogin,
        }
        const objetoCompletoFC_30 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(actualizarFC_30SolicitudBorrador(objetoCompletoFC_30))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_30())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores?.fechapropuestaactividad).toISOString()
        const solicitud = {
            idfc30_notificaciontrasladodepr: data.idfc30_notificaciontrasladodepr,
            fechasolicitud: fechaSolicitud,
            fechapropuestaactividad: fechaVisita, responsabletraslado: valores.responsabletraslado,
            otrainstalacion: valores.otrainstalacion, paracomprayventa: valores.paracomprayventa,
            superviciondocumental: valores.superviciondocumental, supervicionsitio: valores.supervicionsitio,
            propiasalida: valores.propiasalida, noregistradasalida: valores.noregistradasalida,
            tipoinstalacionsalida: valores.tipoinstalacionsalida,
            razonsocialsolicitante: valores.razonsocialsolicitante, responsableinstalacionessolicit: valores.responsableinstalacionessolicit,
            correoelectronicosolicitante: valores.correoelectronicosolicitante, telefonosolicitante: valores.telefonosolicitante + '',
            domiciliosolicitante: valores.domiciliosolicitante, propiarecepcion: valores.propiarecepcion,
            otroclienterecepcion: valores.otroclienterecepcion, tipoinstalacionrecepcion: valores.tipoinstalacionrecepcion,
            noregistradarecepcion: valores.noregistradarecepcion, razonsocialrecepcion: valores.razonsocialrecepcion,
            numeroclienterecepcion: valores.numeroclienterecepcion, responsableinstalacionesrecepci: valores.responsableinstalacionesrecepci,
            correoelectronicorecepcion: valores.correoelectronicorecepcion, telefonorecepcion: valores.telefonorecepcion + '',
            domiciliorecepcion: valores.domiciliorecepcion, observaciones: valores.observaciones,
            idestatusdesolicitudes: 1, idlogin: idlogin,
        }
        const objetoCompletoFC_30 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(enviarBorradorFC_30(objetoCompletoFC_30))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc30_notificaciontrasladodepr
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_30 = 5
            const tabla = tablaFC_30
            await dispatch(actualizarFC_30Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_30())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechasolicitud)?.toISOString()
        let fechaVisita = new Date(valores.fechapropuestaactividad)?.toISOString()
        const solicitud = {
            idfc30_notificaciontrasladodepr: data.idfc30_notificaciontrasladodepr,
            fechasolicitud: fechaSolicitud,
            fechapropuestaactividad: fechaVisita, responsabletraslado: valores.responsabletraslado,
            otrainstalacion: valores.otrainstalacion, paracomprayventa: valores.paracomprayventa,
            superviciondocumental: valores.superviciondocumental, supervicionsitio: valores.supervicionsitio,
            propiasalida: valores.propiasalida, noregistradasalida: valores.noregistradasalida,
            tipoinstalacionsalida: valores.tipoinstalacionsalida,
            razonsocialsolicitante: valores.razonsocialsolicitante, responsableinstalacionessolicit: valores.responsableinstalacionessolicit,
            correoelectronicosolicitante: valores.correoelectronicosolicitante, telefonosolicitante: valores.telefonosolicitante + '',
            domiciliosolicitante: valores.domiciliosolicitante, propiarecepcion: valores.propiarecepcion,
            otroclienterecepcion: valores.otroclienterecepcion, tipoinstalacionrecepcion: valores.tipoinstalacionrecepcion,
            noregistradarecepcion: valores.noregistradarecepcion, razonsocialrecepcion: valores.razonsocialrecepcion,
            numeroclienterecepcion: valores.numeroclienterecepcion, responsableinstalacionesrecepci: valores.responsableinstalacionesrecepci,
            correoelectronicorecepcion: valores.correoelectronicorecepcion, telefonorecepcion: valores.telefonorecepcion + '',
            domiciliorecepcion: valores.domiciliorecepcion, observaciones: valores.observaciones,
            idestatusdesolicitudes: 5, idlogin: idlogin,
        }
        const objetoCompletoFC_30 = {
            solicitud,
            productos,
            //files,
            //filesProductos
        }
        await dispatch(actualizarFC_30Solicitud(objetoCompletoFC_30))
        const idSolicitud = data.idfc30_notificaciontrasladodepr
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_30 = 5
        const tabla = tablaFC_30
        await dispatch(actualizarFC_30Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_30())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    let [resposableRelacionados, setResposableRelacionados] = React.useState([])
    let [activeresponsable, setActiveResponsable] = React.useState(true)
    const setDomicilio = (target) => {
        let datos = target.split('/')

        for (let dato in instalacionesCliente) {
            if ((instalacionesCliente[dato].idanexocliente+'') == datos?.[0]) {
                //const telefono = dato.telefono
                setResposableRelacionados(instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                //const correoelectronico = dato.correoelectronico
                const domicilioproducto = instalacionesCliente[dato].informaciongeneralinstalacioncliente.calle + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.colonia + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.localidad + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.municipio + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.estado + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                setActiveResponsable(false)
                return { domicilioproducto }
            }
        }
        return ''
    }
    const setResponsablesSalida = (target) => {
        for (let dato in resposableRelacionados) {
            if (resposableRelacionados[dato].nombreresponsable === target) {
                const telefono = resposableRelacionados[dato].telefono
                const correoelectronico = resposableRelacionados[dato].correoelectronico
                return { telefono, correoelectronico }
            }
        }
        return ''
    }
    let [resposableRecepcion, setResposableRecepcion] = React.useState([])
    let [activeresponsablerecepcion, setActiveResponsableRecepcion] = React.useState(true)
    const setDomicilioRecepcion = (target) => {
        let datos = target.split('/')
        for (let dato in instalacionesCliente) {
            if ((instalacionesCliente[dato].idanexocliente+'') == datos?.[0]) {
                setResposableRecepcion(instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                const domicilioproducto = instalacionesCliente[dato].informaciongeneralinstalacioncliente.calle + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.colonia + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.localidad + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.municipio + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.estado + "," +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                setActiveResponsableRecepcion(false)
                return { domicilioproducto }
            }
        }
        return ''
    }
    const setResponsableRecepcion = (target) => {
        for (let dato in resposableRecepcion) {
            if (resposableRecepcion[dato].nombreresponsable === target) {
                const telefono = resposableRecepcion[dato].telefono
                const correoelectronico = resposableRecepcion[dato].correoelectronico
                return { telefono, correoelectronico }
            }
        }
        return ''
    }
    let [resposableRecepcionOtro, setResposableRecepcionOtro] = React.useState([])
    let [activeresponsablerecepcionOtro, setActiveResponsableRecepcionOtro] = React.useState(true)
    const setDomicilioRecepcionOtroCliente = (target) => {
        let datos = target.split('/')
        for (let dato in instalacionesBusquedaCliente) {
            if ((instalacionesBusquedaCliente[dato].idanexocliente+'') == datos?.[0]) {
                setResposableRecepcionOtro(instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                const domicilioproducto = instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.calle + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.numerointerior + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.numeroexterior + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.colonia + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.localidad + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.municipio + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.estado + "," +
                    instalacionesBusquedaCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                setActiveResponsableRecepcionOtro(false)
                return { domicilioproducto }
            }
        }
        return ''
    }
    const setResponsableRecepcionOtro = (target) => {
        for (let dato in resposableRecepcionOtro) {
            if (resposableRecepcionOtro[dato].nombreresponsable === target) {
                const telefono = resposableRecepcionOtro[dato].telefono
                const correoelectronico = resposableRecepcionOtro[dato].correoelectronico
                return { telefono, correoelectronico }
            }
        }
        return ''
    }
    let instalacionesBusquedaCliente = useSelector(store => store.FC_30Solicitud.instalacionesRelacionadas)
    const [busqueda, setbusqueda] = React.useState('')
    const buscarNumeroCliente = async (numerosocio) => {
        let instalacionesRelacionadas = await dispatch(ObtenerInstalacionesCliente(numerosocio))
        if (instalacionesRelacionadas.payload !== undefined) setbusqueda('Socio encontrado')
        else setbusqueda('Socio no encontrado')

    }

    const setNoRegistradaRecepcion = async (values) => {
        if (values.superviciondocumental) {
            if (values.propiasalida && !values.noregistradarecepcion) {
                await dispatch(actualizarFC_30PaginaActiva(paginaActiva - 1))
            }
        }
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_30
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_30(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2 text-center'>
                            <div className='row'>
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de traslado de producto'} />

                                </div>
                                {
                                    !modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                        <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                            aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                botonGuardarComoBorrador(values)}
                                        >
                                            <SaveIcon />
                                            {
                                                modoEdicionBorrador ? (
                                                    <div className="badge text-dark textoNormal textoModal">
                                                        Guardar cambios en borrador
                                                    </div>) : (
                                                    <div className="badge text-dark textoNormal textoModal">
                                                        Guardar como borrador
                                                    </div>
                                                )
                                            }
                                        </IconButton>
                                    </div>
                                }
                                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 text-center">
                                    <h1></h1>
                                </div>
                                {
                                    !modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                        <Fragment>
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                            >
                                                <FormatClearIcon />
                                                <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                            </IconButton>
                                        </Fragment>
                                    </div>
                                }
                            </div>
                            {paginaActiva === 1 ?
                                (
                                    <div className='text-center' style={{ textAlign: 'center', marginLeft: '3%' }}>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN DEL SOLICITANTE </h6>
                                        </div>
                                        <div className='row justify-content-start'>
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                <div className="form-floating mb-3">
                                                    <input type="date" className={`form-control ${fc_30Map.fechapropuestaactividadcheck !== undefined ? (
                                                        fc_30Map?.fechapropuestaactividadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='Fecha propuesta' min={fechaHoy}
                                                        name="fechapropuestaactividad"
                                                        value={values.fechapropuestaactividad}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor='floatingInput'>Fecha de visita propuesta</label>
                                                    <span className='text-danger'>{fc_30Map?.fechapropuestaactividadcheck ? fc_30Map?.fechapropuestaactividad : ''}</span>
                                                    {touched.fechapropuestaactividad && errors.fechapropuestaactividad && <div className="text-danger">{errors.fechapropuestaactividad}</div>}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-6">
                                                    <select className={`form-select ${fc_30Map.responsabletrasladocheck !== undefined ?
                                                        (fc_30Map?.responsabletrasladocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        name="responsabletraslado"
                                                        value={values.responsabletraslado}
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.responsabletraslado = e.target.value
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    >
                                                        <option value="">Seleccione un responsable de traslado</option>
                                                        {
                                                            instalacionesCliente?.map((instalaciones, index) => (
                                                                instalaciones.idtipoanexo !== 3 &&
                                                                instalaciones.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente.map((opcion, index) => (
                                                                    <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                ))
                                                            ))
                                                        }
                                                    </select>
                                                    <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                    <span className='text-danger'>{fc_30Map?.responsabletrasladocheck === true ? fc_30Map?.responsabletraslado : ''}</span>
                                                    {touched.responsabletraslado && errors.responsabletraslado && <div className="text-danger">{errors.responsabletraslado}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>LA EMPRESA A TRAVÉS DE SU REPRESENTANTE LEGAL Y/O AUTORIZADO SOLICITA EL SERVICIO DE INSPECCIÓN DURANTE EL</h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                <h6 className='text-center'><b>TRASLADO DE PRODUCTO</b></h6>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <input className={`form-check-input me-1 ${fc_30Map.otrainstalacioncheck !== undefined ? (
                                                        fc_30Map?.otrainstalacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.otrainstalacion} id='otrainstalacion'
                                                        name="otrainstalacion"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.otrainstalacion = e.target.checked
                                                            newValues.paracomprayventa = !e.target.checked
                                                            newValues.propiasalida = true
                                                            newValues.propiarecepcion = true
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                        A otra instalación propiedad
                                                    </label><br />
                                                    <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                        de la misma empresa
                                                    </label><br />
                                                    <span className='text-danger'>{fc_30Map?.otrainstalacion}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <input className={`form-check-input me-1 ${fc_30Map.paracomprayventacheck !== undefined ? (
                                                        fc_30Map?.paracomprayventacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.paracomprayventa} id='paracomprayventa'
                                                        name="paracomprayventa"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.paracomprayventa = e.target.checked
                                                            newValues.otrainstalacion = !e.target.checked
                                                            newValues.propiasalida = false
                                                            newValues.propiarecepcion = false
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />

                                                    <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                        Para la compra-venta de producto
                                                    </label><br />
                                                    <span className='text-danger'>{fc_30Map?.paracomprayventacheck ? fc_30Map?.paracomprayventa : ''}</span>
                                                </div>
                                                {touched.otrainstalacion && errors.otrainstalacion && <div className="text-danger">{errors.otrainstalacion}</div>}
                                            </div>
                                        </div>
                                        <br />
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>OPCIONES DEL SERVICIO DEL TRASLADO</h6>
                                        </div>
                                        <div className='row align-items-center'>
                                            <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                    <input className={`form-check-input me-1 ${fc_30Map.superviciondocumentalcheck !== undefined ? (
                                                        fc_30Map?.superviciondocumentalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.superviciondocumental} id='superviciondocumental'
                                                        name="superviciondocumental"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.superviciondocumental = e.target.checked
                                                            newValues.supervicionsitio = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                        Supervisión Documental (TSD)
                                                    </label>
                                                    <span className='text-danger'>{fc_30Map?.superviciondocumentalcheck ? fc_30Map?.superviciondocumental : ''}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <input className={`form-check-input me-1 ${fc_30Map.supervicionsitiocheck !== undefined ? (
                                                        fc_30Map?.supervicionsitiocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.supervicionsitio} id='supervicionsitio'
                                                        name="supervicionsitio"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.supervicionsitio = e.target.checked
                                                            newValues.superviciondocumental = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <Tooltip title={`Seguimiento presencial por la UI`} arrow>
                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            Supervisión en sitio
                                                        </label>
                                                    </Tooltip><br />
                                                    <span className='text-danger'>{fc_30Map?.supervicionsitiocheck ? fc_30Map?.supervicionsitio : ''}</span>
                                                </div>
                                                {touched.superviciondocumental && errors.superviciondocumental && <div className="text-danger">{errors.superviciondocumental}</div>}
                                                {touched.noregistradasalida && errors.trasladosalida && <div className="text-danger">{errors.trasladosalida}</div>}
                                                <br /><br />
                                                <small className='text-center'>En la opción de traslado por supervisión en sitio, el responsable del pago del servicio será el solicitante</small>
                                            </div>
                                        </div>
                                        <br />
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>SALIDA DEL PRODUCTO</h6>
                                        </div>

                                        <div className='row justify-content-start'>
                                            {values.otrainstalacion !== true ?
                                                <Fragment>
                                                    <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                        <input className={`form-check-input me-1 ${fc_30Map.propiasalidacheck !== undefined ? (
                                                            fc_30Map?.propiasalidacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.propiasalida} id='propiasalida'
                                                            name="propiasalida"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.propiasalida = e.target.checked
                                                                newValues.noregistradasalida = !e.target.checked
                                                                newValues.responsableinstalacionessolicit = ''
                                                                newValues.correoelectronicosolicitante = ''
                                                                newValues.telefonosolicitante = ''
                                                                newValues.domiciliosolicitante = ''
                                                                newValues.razonsocialsolicitante = ''
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            De mi instalación
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                        <input className={`form-check-input me-1 ${fc_30Map.noregistradasalidacheck !== undefined ? (
                                                            fc_30Map?.noregistradasalidacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.noregistradasalida} id='noregistradasalida'
                                                            name="noregistradasalida"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.noregistradasalida = e.target.checked
                                                                newValues.propiasalida = !e.target.checked
                                                                newValues.propiarecepcion = e.target.checked
                                                                newValues.responsableinstalacionessolicit = ''
                                                                newValues.correoelectronicosolicitante = ''
                                                                newValues.telefonosolicitante = ''
                                                                newValues.domiciliosolicitante = ''
                                                                newValues.razonsocialsolicitante = ''
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            Empresa no registrada en COMERCAM
                                                        </label>
                                                    </div>
                                                    {touched.propiasalida && errors.propiasalida && <div className="text-danger">{errors.propiasalida}</div>}<br />
                                                </Fragment> : ''
                                            }


                                            {values.propiasalida ?
                                                <Fragment>
                                                    <br />
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                        <div className="form-floating mb-6">
                                                            <select className={`form-select ${fc_30Map.tipoinstalacionsalidacheck !== undefined ?
                                                                (fc_30Map?.tipoinstalacionsalidacheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                name="tipoinstalacionsalida"
                                                                value={values.tipoinstalacionsalida}
                                                                onChange={e => {
                                                                    const result = setDomicilio(e.target.value)
                                                                    const { ...newValues } = values
                                                                    newValues.tipoinstalacionsalida = e.target.value
                                                                    if (result !== '') {
                                                                        newValues.domiciliosolicitante = result.domicilioproducto
                                                                    }
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                <option value="">Seleccione un tipo de instalación</option>
                                                                {
                                                                    instalacionesCliente?.map((instalaciones, index) => (
                                                                        <option value={`${instalaciones.idanexocliente + '/' + instalaciones.idtipoanexo + ''}`}>
                                                                            {`${instalaciones.idtipoanexo === 1 ? 'Unidad Producción: ' + instalaciones.informaciongeneralinstalacioncliente.alias :
                                                                                instalaciones.idtipoanexo === 2 ? 'Unidad de Envasado: ' + instalaciones.informaciongeneralinstalacioncliente.alias :
                                                                                    instalaciones.idtipoanexo === 3 ? 'Unidad Almacen: ' + instalaciones.informaciongeneralinstalacioncliente.alias : ''}`}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                            <span className='text-danger'>{fc_30Map?.responsableinstalacionessolicitcheck === true ? fc_30Map?.responsableinstalacionessolicit : ''}</span>
                                                            {touched.responsableinstalacionessolicit && errors.responsableinstalacionessolicit && <div className="text-danger">{errors.responsableinstalacionessolicit}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                        <div className="form-floating mb-6">
                                                            <select className={`form-select ${fc_30Map.responsableinstalacionessolicitcheck !== undefined ?
                                                                (fc_30Map?.responsableinstalacionessolicitcheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                name="responsableinstalacionessolicit"
                                                                value={values.responsableinstalacionessolicit}
                                                                onChange={e => {
                                                                    const result = setResponsablesSalida(e.target.value)
                                                                    const { ...newValues } = values
                                                                    newValues.responsableinstalacionessolicit = e.target.value
                                                                    if (result !== '') {
                                                                        newValues.correoelectronicosolicitante = result.correoelectronico
                                                                        newValues.telefonosolicitante = result.telefono
                                                                        //newValues.domiciliosolicitante = result.domicilioproducto
                                                                    }
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                <option value="">Seleccione un responsable</option>
                                                                {
                                                                    resposableRelacionados?.map((opcion, index) => (
                                                                        <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                            <span className='text-danger'>{fc_30Map?.responsableinstalacionessolicitcheck === true ? fc_30Map?.responsableinstalacionessolicit : ''}</span>
                                                            {touched.responsableinstalacionessolicit && errors.responsableinstalacionessolicit && <div className="text-danger">{errors.responsableinstalacionessolicit}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'><br />
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_30Map.correoelectronicosolicitantecheck !== undefined ? (
                                                                fc_30Map?.correoelectronicosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                disabled
                                                                placeholder='correoelectronicosolicitante'
                                                                name="correoelectronicosolicitante"
                                                                value={values.correoelectronicosolicitante}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor="floatingInput">Correo electrónico</label>
                                                            <br />
                                                            <span className='text-danger'>{fc_30Map?.correoelectronicosolicitantecheck ? fc_30Map?.correoelectronicosolicitante : ''}</span>
                                                            {touched.correoelectronicosolicitante && errors.correoelectronicosolicitante && <div className="text-danger">{errors.correoelectronicosolicitante}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'><br />
                                                        <div className="form-floating mb-3">
                                                            <input type="number" min='0' className={`form-control ${fc_30Map.telefonosolicitantecheck !== undefined ? (
                                                                fc_30Map?.telefonosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Telefono'
                                                                name="telefonosolicitante"
                                                                value={values.telefonosolicitante}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                disabled />
                                                            <label htmlFor="floatingInput">Teléfono</label>
                                                            <br />
                                                            <span className='text-danger'>{fc_30Map?.telefonosolicitantecheck ? fc_30Map?.telefonosolicitante : ''}</span>
                                                            {touched.telefonosolicitante && errors.telefonosolicitante && <div className="text-danger">{errors.telefonosolicitante}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_30Map.domiciliosolicitantecheck !== undefined ? (
                                                                fc_30Map?.domiciliosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='domiciliosolicitante'
                                                                disabled
                                                                name="domiciliosolicitante"
                                                                value={values.domiciliosolicitante}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            <label htmlFor="floatingInput">Domicilio completo</label>
                                                            <span className='text-danger'>{fc_30Map?.domiciliosolicitantecheck ? fc_30Map?.domiciliosolicitante : ''}</span>
                                                            {touched.domiciliosolicitante && errors.domiciliosolicitante && <div className="text-danger">{errors.domiciliosolicitante}</div>}
                                                        </div>
                                                    </div>
                                                </Fragment> :
                                                values.noregistradasalida ?
                                                    <Fragment>
                                                        <br />
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.razonsocialsolicitantecheck !== undefined ? (
                                                                    fc_30Map?.razonsocialsolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='razonsocialsolicitante'
                                                                    name="razonsocialsolicitante"
                                                                    value={values.razonsocialsolicitante}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Razón social</label>
                                                                <br />
                                                                <span className='text-danger'>{fc_30Map?.razonsocialsolicitantecheck ? fc_30Map?.razonsocialsolicitante : ''}</span>
                                                                {touched.razonsocialsolicitante && errors.razonsocialsolicitante && <div className="text-danger">{errors.razonsocialsolicitante}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.responsableinstalacionessolicitcheck !== undefined ? (
                                                                    fc_30Map?.responsableinstalacionessolicitcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='responsableinstalacionessolicit'
                                                                    name="responsableinstalacionessolicit"
                                                                    value={values.responsableinstalacionessolicit}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Responsable de instalación</label>
                                                                <span className='text-danger'>{fc_30Map?.responsableinstalacionessolicitcheck ? fc_30Map?.responsableinstalacionessolicit : ''}</span>
                                                                {touched.responsableinstalacionessolicit && errors.responsableinstalacionessolicit && <div className="text-danger">{errors.responsableinstalacionessolicit}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="number" className={`form-control ${fc_30Map.telefonosolicitantecheck !== undefined ? (
                                                                    fc_30Map?.telefonosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='telefonosolicitante'
                                                                    name="telefonosolicitante"
                                                                    value={values.telefonosolicitante}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Teléfono</label>
                                                                <span className='text-danger'>{fc_30Map?.telefonosolicitantecheck ? fc_30Map?.telefonosolicitante : ''}</span>
                                                                {touched.telefonosolicitante && errors.telefonosolicitante && <div className="text-danger">{errors.telefonosolicitante}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.correoelectronicosolicitantecheck !== undefined ? (
                                                                    fc_30Map?.correoelectronicosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='correoelectronicosolicitante'
                                                                    name="correoelectronicosolicitante"
                                                                    value={values.correoelectronicosolicitante}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Correo electrónico</label>
                                                                <span className='text-danger'>{fc_30Map?.correoelectronicosolicitantecheck ? fc_30Map?.correoelectronicosolicitante : ''}</span>
                                                                {touched.correoelectronicosolicitante && errors.correoelectronicosolicitante && <div className="text-danger">{errors.correoelectronicosolicitante}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.domiciliosolicitantecheck !== undefined ? (
                                                                    fc_30Map?.domiciliosolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='domiciliosolicitante'
                                                                    name="domiciliosolicitante"
                                                                    value={values.domiciliosolicitante}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Domicilio Completo</label>
                                                                <br />
                                                                <span className='text-danger'>{fc_30Map?.domiciliosolicitantecheck ? fc_30Map?.domiciliosolicitante : ''}</span>
                                                                {
                                                                    values.propiasalida !== true &&
                                                                    <div className="text-danger">Ingresar el domicilio completo (Calle, Núm. interior, Núm. exterior, Colonia, Municipio, Estado, Código postal)</div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Fragment> : ''}
                                        </div> <br />
                                    </div>
                                ) :
                                paginaActiva === 2 ?
                                    (<div style={{ textAlign: 'center', marginLeft: '3%' }}>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>RECEPCIÓN DEL PRODUCTO</h6>
                                        </div>
                                        <div className='row justify-content-start'>
                                            {
                                                values.otrainstalacion !== true ?
                                                    values.noregistradasalida ?
                                                        <Fragment>
                                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                                <input className={`form-check-input me-1 ${fc_30Map.propiarecepcioncheck !== undefined ? (
                                                                    fc_30Map?.propiarecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                    checked={values.propiarecepcion} id='propiarecepcion'
                                                                    name="propiarecepcion"
                                                                    onChange={e => {
                                                                        const { ...newValues } = values
                                                                        newValues.propiarecepcion = true
                                                                        newValues.otroclienterecepcion = false
                                                                        newValues.noregistradarecepcion = false
                                                                        newValues.responsableinstalacionesrecepci = ''
                                                                        newValues.correoelectronicorecepcion = ''
                                                                        newValues.telefonorecepcion = ''
                                                                        newValues.domiciliorecepcion = ''
                                                                        newValues.razonsocialrecepcion = ''
                                                                        setValues(newValues)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                    Instalaciones propias
                                                                </label>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8'></div>
                                                        </Fragment> :
                                                        values.paracomprayventa && values.propiasalida &&
                                                        <Fragment>

                                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                                <input className={`form-check-input me-1 ${fc_30Map.otroclienterecepcioncheck !== undefined ? (
                                                                    fc_30Map?.otroclienterecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                    checked={values.otroclienterecepcion} id='otroclienterecepcion'
                                                                    name="otroclienterecepcion"
                                                                    onChange={e => {
                                                                        const { ...newValues } = values
                                                                        newValues.otroclienterecepcion = e.target.checked
                                                                        newValues.noregistradarecepcion = false
                                                                        newValues.propiarecepcion = false
                                                                        newValues.responsableinstalacionesrecepci = ''
                                                                        newValues.correoelectronicorecepcion = ''
                                                                        newValues.telefonorecepcion = ''
                                                                        newValues.domiciliorecepcion = ''
                                                                        newValues.razonsocialrecepcion = ''
                                                                        setValues(newValues)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                    A otro cliente del COMERCAM
                                                                </label>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                                <input className={`form-check-input me-1 ${fc_30Map.noregistradarecepcioncheck !== undefined ? (
                                                                    fc_30Map?.noregistradarecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                    checked={values.noregistradarecepcion} id='noregistradarecepcion'
                                                                    name="noregistradarecepcion"
                                                                    onChange={e => {
                                                                        const { ...newValues } = values
                                                                        newValues.noregistradarecepcion = e.target.checked
                                                                        newValues.otroclienterecepcion = false
                                                                        newValues.propiarecepcion = false
                                                                        newValues.responsableinstalacionesrecepci = ''
                                                                        newValues.correoelectronicorecepcion = ''
                                                                        newValues.telefonorecepcion = ''
                                                                        newValues.domiciliorecepcion = ''
                                                                        newValues.razonsocialrecepcion = ''
                                                                        setValues(newValues)
                                                                        const cambio = setNoRegistradaRecepcion(values)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                    Empresa no registrada en COMERCAM
                                                                </label>
                                                            </div>
                                                        </Fragment>
                                                    : ''
                                            }
                                            <br />
                                            {values.otroclienterecepcion ?
                                                <Fragment>
                                                    <br />
                                                    <div className='col-md-5'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_30Map.numeroclienterecepcioncheck !== undefined ? (
                                                                fc_30Map?.numeroclienterecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                placeholder='numeroclienterecepcion'
                                                                name="numeroclienterecepcion"
                                                                value={values.numeroclienterecepcion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor="floatingInput">Número de cliente</label>
                                                            <span className='text-danger'>{fc_30Map?.numeroclienterecepcioncheck ? fc_30Map?.numeroclienterecepcion : ''}</span>
                                                            <span className={busqueda == 'Socio encontrado' ? 'text-success' : 'text-danger'}>{busqueda}</span>
                                                            {touched.numeroclienterecepcion && errors.numeroclienterecepcion && <div className="text-danger">{errors.numeroclienterecepcion}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-1 text-center' style={{ textAlign: 'center' }}>
                                                        <div className='row'>
                                                            <button type="submit" className={'btn btn-success'} onClick={() => buscarNumeroCliente(values.numeroclienterecepcion)}>Buscar</button>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-6">
                                                            <select className={`form-select ${fc_30Map.tipoinstalacionrecepcioncheck !== undefined ?
                                                                (fc_30Map?.tipoinstalacionrecepcioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                name="tipoinstalacionrecepcion"
                                                                value={values.tipoinstalacionrecepcion}
                                                                onChange={e => {
                                                                    const result = setDomicilioRecepcionOtroCliente(e.target.value)
                                                                    const { ...newValues } = values
                                                                    newValues.tipoinstalacionrecepcion = e.target.value
                                                                    if (result !== '') {
                                                                        newValues.domiciliorecepcion = result.domicilioproducto
                                                                    }
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}>
                                                                <option value="">Seleccione un tipo de instalación</option>
                                                                {
                                                                    instalacionesBusquedaCliente?.map((opcion, index) => (
                                                                        <option value={`${opcion.idanexocliente + '/' + opcion.idtipoanexo + ''}`}>
                                                                            {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias :
                                                                                opcion.idtipoanexo === 2 ? 'Unidad de Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias :
                                                                                    opcion.idtipoanexo === 3 ? 'Unidad Almacen: ' + opcion.informaciongeneralinstalacioncliente.alias : ''}`}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                            <span className='text-danger'>{fc_30Map?.tipoinstalacionrecepcioncheck === true ? fc_30Map?.responsableinstalacionesrecepci : ''}</span>
                                                            {touched.tipoinstalacionrecepcion && errors.tipoinstalacionrecepcion && <div className="text-danger">{errors.tipoinstalacionrecepcion}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-6">
                                                            <select className={`form-select ${fc_30Map.responsableinstalacionesrecepcicheck !== undefined ?
                                                                (fc_30Map?.responsableinstalacionesrecepcicheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                name="responsableinstalacionesrecepci"
                                                                value={values.responsableinstalacionesrecepci}
                                                                onChange={e => {
                                                                    const result = setResponsableRecepcionOtro(e.target.value)
                                                                    const { ...newValues } = values
                                                                    newValues.responsableinstalacionesrecepci = e.target.value
                                                                    if (result !== '') {
                                                                        newValues.correoelectronicorecepcion = result.correoelectronico
                                                                        newValues.telefonorecepcion = result.telefono
                                                                        //newValues.domiciliorecepcion = result.domicilioproducto
                                                                    }
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                <option value="">Seleccione un responsable</option>
                                                                {
                                                                    resposableRecepcionOtro.map((opcion, index) => (
                                                                        <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                            <span className='text-danger'>{fc_30Map?.responsableinstalacionesrecepcicheck === true ? fc_30Map?.responsableinstalacionesrecepci : ''}</span>
                                                            {touched.responsableinstalacionesrecepci && errors.responsableinstalacionesrecepci && <div className="text-danger">{errors.responsableinstalacionesrecepci}</div>}
                                                        </div>
                                                    </div>

                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_30Map.correoelectronicorecepcioncheck !== undefined ? (
                                                                fc_30Map?.correoelectronicorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                disabled
                                                                placeholder='correoelectronicorecepcion'
                                                                name="correoelectronicorecepcion"
                                                                value={values.correoelectronicorecepcion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor="floatingInput">Correo electrónico</label>
                                                            <span className='text-danger'>{fc_30Map?.correoelectronicorecepcioncheck ? fc_30Map?.correoelectronicorecepcion : ''}</span>
                                                            {touched.correoelectronicorecepcion && errors.correoelectronicorecepcion && <div className="text-danger">{errors.correoelectronicorecepcion}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-3">
                                                            <input type="number" min='0' className={`form-control ${fc_30Map.telefonorecepcioncheck !== undefined ? (
                                                                fc_30Map?.telefonorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Telefono'
                                                                name="telefonorecepcion"
                                                                value={values.telefonorecepcion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                disabled />
                                                            <label htmlFor="floatingInput">Teléfono</label>
                                                            <span className='text-danger'>{fc_30Map?.telefonorecepcioncheck ? fc_30Map?.telefonorecepcion : ''}</span>
                                                            {touched.telefonorecepcion && errors.telefonorecepcion && <div className="text-danger">{errors.telefonorecepcion}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_30Map.domiciliorecepcioncheck !== undefined ? (
                                                                fc_30Map?.domiciliorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='domiciliosolicitante'
                                                                disabled
                                                                name="domiciliorecepcion"
                                                                value={values.domiciliorecepcion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            <label htmlFor="floatingInput">Domicilio completo</label>
                                                            <span className='text-danger'>{fc_30Map?.domiciliorecepcioncheck ? fc_30Map?.domiciliorecepcion : ''}</span>
                                                            {touched.domiciliorecepcion && errors.domiciliorecepcion && <div className="text-danger">{errors.domiciliorecepcion}</div>}
                                                        </div>
                                                    </div>
                                                </Fragment> :
                                                values.noregistradarecepcion ?
                                                    <Fragment>
                                                        <br />
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.razonsocialrecepcioncheck !== undefined ? (
                                                                    fc_30Map?.razonsocialrecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='razonsocialrecepcion'
                                                                    name="razonsocialrecepcion"
                                                                    value={values.razonsocialrecepcion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Razón social</label>
                                                                <span className='text-danger'>{fc_30Map?.razonsocialrecepcioncheck ? fc_30Map?.razonsocialrecepcion : ''}</span>
                                                                {touched.razonsocialrecepcion && errors.razonsocialrecepcion && <div className="text-danger">{errors.razonsocialrecepcion}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.responsableinstalacionesrecepcicheck !== undefined ? (
                                                                    fc_30Map?.responsableinstalacionesrecepcicheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='responsableinstalacionesrecepci'
                                                                    name="responsableinstalacionesrecepci"
                                                                    value={values.responsableinstalacionesrecepci}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Responsable de instalación</label>
                                                                <span className='text-danger'>{fc_30Map?.responsableinstalacionesrecepcicheck ? fc_30Map?.responsableinstalacionesrecepci : ''}</span>
                                                                {touched.responsableinstalacionesrecepci && errors.responsableinstalacionesrecepci && <div className="text-danger">{errors.responsableinstalacionesrecepci}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="number" className={`form-control ${fc_30Map.telefonorecepcioncheck !== undefined ? (
                                                                    fc_30Map?.telefonorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='telefonorecepcion'
                                                                    name="telefonorecepcion"
                                                                    value={values.telefonorecepcion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Teléfono</label>
                                                                <span className='text-danger'>{fc_30Map?.telefonorecepcioncheck ? fc_30Map?.telefonorecepcion : ''}</span>
                                                                {touched.telefonorecepcion && errors.telefonorecepcion && <div className="text-danger">{errors.telefonorecepcion}</div>}
                                                                {touched.telefonorecepcion && errors.telefonolongrep && <div className="text-danger">{errors.telefonolongrep}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.correoelectronicorecepcioncheck !== undefined ? (
                                                                    fc_30Map?.correoelectronicorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='correoelectronicorecepcion'
                                                                    name="correoelectronicorecepcion"
                                                                    value={values.correoelectronicorecepcion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Correo electrónico</label>
                                                                <span className='text-danger'>{fc_30Map?.correoelectronicorecepcioncheck ? fc_30Map?.correoelectronicorecepcion : ''}</span>
                                                                {touched.correoelectronicorecepcion && errors.correoelectronicorecepcion && <div className="text-danger">{errors.correoelectronicorecepcion}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_30Map.domiciliorecepcioncheck !== undefined ? (
                                                                    fc_30Map?.domiciliorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='domiciliorecepcion'
                                                                    name="domiciliorecepcion"
                                                                    value={values.domiciliorecepcion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Domicilio Completo</label>
                                                                <span className='text-danger'>{fc_30Map?.domiciliorecepcioncheck ? fc_30Map?.domiciliorecepcion : ''}</span>
                                                                {touched.domiciliorecepcion && errors.domiciliorecepcion && <div className="text-danger">{errors.domiciliorecepcion}</div>}
                                                                {values.noregistradarecepcion == true &&
                                                                    <div className="text-danger">Ingresar el domicilio completo (Calle, Núm. interior, Núm. exterior, Colonia, Municipio, Estado, Código postal)</div>
                                                                }
                                                            </div>
                                                        </div>

                                                    </Fragment> : values.propiarecepcion ?
                                                        <Fragment>
                                                            <br />
                                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className="form-floating mb-6">
                                                                    <select className={`form-select ${fc_30Map.tipoinstalacionrecepcioncheck !== undefined ?
                                                                        (fc_30Map?.tipoinstalacionrecepcioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        name="tipoinstalacionrecepcion"
                                                                        value={values.tipoinstalacionrecepcion}
                                                                        onChange={e => {
                                                                            const result = setDomicilioRecepcion(e.target.value)
                                                                            const { ...newValues } = values
                                                                            newValues.tipoinstalacionrecepcion = e.target.value
                                                                            if (result !== '') {
                                                                                newValues.domiciliorecepcion = result.domicilioproducto
                                                                            }
                                                                            setValues(newValues)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    >
                                                                        <option value="">Seleccione un tipo de instalación</option>
                                                                        {
                                                                            instalacionesCliente?.map((instalaciones, index) => (
                                                                                <option value={`${instalaciones.idanexocliente + '/' + instalaciones.idtipoanexo + ''}`}>
                                                                                    {`${instalaciones.idtipoanexo === 1 ? 'Unidad Producción: ' + instalaciones.informaciongeneralinstalacioncliente.alias :
                                                                                        instalaciones.idtipoanexo === 2 ? 'Unidad de Envasado: ' + instalaciones.informaciongeneralinstalacioncliente.alias :
                                                                                            instalaciones.idtipoanexo === 3 ? 'Unidad Almacen: ' + instalaciones.informaciongeneralinstalacioncliente.alias : ''}`}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                                    <span className='text-danger'>{fc_30Map?.tipoinstalacionrecepcioncheck === true ? fc_30Map?.tipoinstalacionrecepcion : ''}</span>
                                                                    {touched.tipoinstalacionrecepcion && errors.tipoinstalacionrecepcion && <div className="text-danger">{errors.tipoinstalacionrecepcion}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <div className="form-floating mb-6">
                                                                    <select className={`form-select ${fc_30Map.responsableinstalacionesrecepcicheck !== undefined ?
                                                                        (fc_30Map?.responsableinstalacionesrecepcicheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        name="responsableinstalacionesrecepci"
                                                                        value={values.responsableinstalacionesrecepci}
                                                                        onChange={e => {
                                                                            const result = setResponsableRecepcion(e.target.value)
                                                                            const { ...newValues } = values
                                                                            newValues.responsableinstalacionesrecepci = e.target.value
                                                                            if (result !== '') {
                                                                                newValues.correoelectronicorecepcion = result.correoelectronico
                                                                                newValues.telefonorecepcion = result.telefono
                                                                                //newValues.domiciliorecepcion = result.domicilioproducto
                                                                            }
                                                                            setValues(newValues)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    >
                                                                        <option value="">Seleccione un responsable</option>
                                                                        {
                                                                            resposableRecepcion.map((opcion, index) => (
                                                                                <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                                    <span className='text-danger'>{fc_30Map?.responsableinstalacionesrecepcicheck === true ? fc_30Map?.responsableinstalacionesrecepci : ''}</span>
                                                                    {touched.responsableinstalacionesrecepci && errors.responsableinstalacionesrecepci && <div className="text-danger">{errors.responsableinstalacionesrecepci}</div>}
                                                                </div>
                                                            </div>

                                                            <div className='col-md-6'><br />
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_30Map.correoelectronicorecepcioncheck !== undefined ? (
                                                                        fc_30Map?.correoelectronicorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        disabled
                                                                        placeholder='correoelectronicorecepcion'
                                                                        name="correoelectronicorecepcion"
                                                                        value={values.correoelectronicorecepcion}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Correo electrónico</label>
                                                                    <span className='text-danger'>{fc_30Map?.correoelectronicorecepcioncheck ? fc_30Map?.correoelectronicorecepcion : ''}</span>
                                                                    {touched.correoelectronicorecepcion && errors.correoelectronicorecepcion && <div className="text-danger">{errors.correoelectronicorecepcion}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'><br />
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" min='0' className={`form-control ${fc_30Map.telefonorecepcioncheck !== undefined ? (
                                                                        fc_30Map?.telefonorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Telefono'
                                                                        name="telefonorecepcion"
                                                                        value={values.telefonorecepcion}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        disabled />
                                                                    <label htmlFor="floatingInput">Teléfono</label>
                                                                    <span className='text-danger'>{fc_30Map?.telefonorecepcioncheck ? fc_30Map?.telefonorecepcion : ''}</span>
                                                                    {touched.telefonorecepcion && errors.telefonorecepcion && <div className="text-danger">{errors.telefonorecepcion}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_30Map.domiciliorecepcioncheck !== undefined ? (
                                                                        fc_30Map?.domiciliorecepcioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='domiciliosolicitante'
                                                                        disabled
                                                                        name="domiciliorecepcion"
                                                                        value={values.domiciliorecepcion}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur} />
                                                                    <label htmlFor="floatingInput">Domicilio completo</label>
                                                                    <span className='text-danger'>{fc_30Map?.domiciliorecepcioncheck ? fc_30Map?.domiciliorecepcion : ''}</span>

                                                                </div>
                                                            </div>
                                                        </Fragment> : ''}
                                        </div>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>CARACTERÍSTICAS DE PRODUCTO</h6>
                                        </div>
                                        <TablaProducto api={{ handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos }} productosMap={fc_30ProductosMap} propia={values.otrainstalacion}></TablaProducto>
                                        <br />
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>ACTIVIDADES POSTERIORES A LA RECEPCIÓN DEL PRODUCTO</h6>
                                        </div>
                                        <div className='row justify-content-start'>
                                            <div className='col-md-12'>
                                                <div className="form-floating mb-3">
                                                    <textarea type="text" className={`form-control ${fc_30Map.observacionescheck !== undefined ? (
                                                        fc_30Map?.observacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        placeholder='observaciones'
                                                        rows="3"
                                                        name="observaciones"
                                                        value={values.observaciones}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor="floatingInput">Observaciones</label>
                                                    <span className='text-danger'>{fc_30Map?.observacionescheck ? fc_30Map?.observaciones : ''}</span>
                                                    {touched.observaciones && errors.observaciones && <div className="text-danger">{errors.observaciones}</div>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    ) :
                                    <Fragment>
                                        {
                                            modoCorreccion &&
                                            <div className={`${estilos.componenteDocFC_30} col-md-12`}>

                                                <DocumentacionFC_30Component> </DocumentacionFC_30Component>
                                            </div>
                                        }
                                        <div className='row justify-content-start'>
                                            <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_30'} />

                                        </div>
                                        <br />
                                        {
                                            !modoCorreccion ?
                                                <div>
                                                    <div className="row mt-4">
                                                        {
                                                            modoEdicionBorrador ? (
                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                    <button type="submit"
                                                                        onClick={() => { botonEnviarSolicitudBorradorFC_30(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                                </div>
                                                            ) : (
                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                    <button type="submit"
                                                                        onClick={() => { botonEnviarSolicitudFC_30(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        disabled={!terminosYCondiciones}>Enviar</button>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                                :
                                                <div className="row mt-4">
                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                        <button type="submit"
                                                            onClick={() => { botonEnviarCorreccionesFC_30(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                            disabled={!terminosYCondiciones}
                                                            className={`btn ${estilos.botonNaranjaRedondo}`}>Enviar correcciones</button>
                                                    </div>
                                                </div>
                                        }
                                    </Fragment>
                            }
                            <br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                        </div>
                    </form>
                )}
            </Formik>
        </Fragment>
    )
}
export default withRouter(FormularioFC30BeneficiarioComponent)
